import { Component, input, viewChild } from '@angular/core';
import { Notification, Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-chunk-load-error-notification',
  imports: [Notification, NgIcon, Button, TranslocoPipe],
  templateUrl: './chunk-load-error-notification.html',
})
export class ChunkLoadErrorNotification {
  notification = viewChild(Notification);
  uuid = input.required<string>();
  duration = input.required<number>();

  protected onClickReload() {
    this.notification()?.dismiss();
    window.location.reload();
  }
}
